export default function FAQSection() {
  const faqs = [
    {
      q: '51黑料网的内容多久更新一次？',
      a: '51黑料网保持黑料每日更新的节奏，今日黑料最新动态从信息确认到上线平均不超过30分钟。我们的编辑团队7×24小时轮值，确保你随时打开51黑料网首页都能看到新鲜的黑料新鲜事。',
    },
    {
      q: '51黑料网的信息来源可靠吗？',
      a: '我们坚持多方交叉验证原则，每一条上线的今日黑料最新内容都经过至少两个独立信息源的核实。51黑料今日发布的所有爆料均标注信息来源与可信度等级，帮助读者自行判断。',
    },
    {
      q: '如何在手机上更方便地访问51黑料网？',
      a: '51黑料网已全面适配移动端浏览体验，你只需在手机浏览器中访问51黑料网入口即可。建议将首页添加至手机桌面，即可像使用App一样每日获取每日黑料更新，无需额外下载任何应用。',
    },
    {
      q: '看到感兴趣的爆料可以投稿吗？',
      a: '当然可以！我们欢迎读者提供线索与爆料素材。你可以通过本页的联系方式向我们投稿，51黑料网承诺对所有爆料人信息严格保密，有价值的黑料线索一经采用还将获得相应奖励。',
    },
  ];

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-400 bg-primary-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-question-line"></i>
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于51黑料网，你可能想了解的事情</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-lg p-5"
            >
              <h3 className="font-heading text-base font-bold text-foreground-100 mb-2.5">
                <span className="text-primary-400 mr-2">Q:</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-6">
                <span className="text-accent-400 mr-2 font-semibold">A:</span>
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}